import {
    OnlineUsers,
    AreaChartCard,
    CountCards,
    CountryWiseDownload,
    CreatedCommunities,
    DevicesCards,
    JoinedUsers,
    NotificationsCard,
    UpdatedPosts,
    WelcomeCard
} from "components";

const Dashboard = () => {
    return (
        <div className="flex flex-col justify-start items-start px-4 md:px-10 py-10 w-full">
            <div className="flex justify-start items-start w-full flex-wrap">
                <div className="w-full lg:w-1/2 px-4 py-4">
                    <WelcomeCard />
                </div>
                <div className="w-full lg:w-1/2  px-4 py-4">
                    <CountCards />
                </div>
            </div>
            <div className="row px-4 py-4 w-full">
                <AreaChartCard />
                <DevicesCards />
            </div>
            <div className="flex justify-start items-start w-full flex-wrap">
                <div
                    className="flex flex-col w-full md:w-1/2 xl:w-1/3 px-4 py-4"
                    style={{ height: 500 }}
                >
                    <OnlineUsers />
                </div>
                <div
                    className="flex flex-col w-full md:w-1/2 xl:w-1/3 px-4 py-4"
                    style={{ height: 500 }}
                >
                    <CountryWiseDownload />
                </div>
                <div
                    className="flex flex-col w-full md:w-1/2 xl:w-1/3 px-4 py-4"
                    style={{ height: 500 }}
                >
                    <UpdatedPosts />
                </div>
                <div
                    className="flex flex-col w-full md:w-1/2 xl:w-1/3 px-4 py-4"
                    style={{ height: 500 }}
                >
                    <NotificationsCard />
                </div>
                <div
                    className="flex flex-col w-full md:w-1/2 xl:w-1/3 px-4 py-4"
                    style={{ height: 500 }}
                >
                    <CreatedCommunities />
                </div>
                <div
                    className="flex flex-col w-full md:w-1/2 xl:w-1/3 px-4 py-4"
                    style={{ height: 500 }}
                >
                    <JoinedUsers />
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
